let instance = null;
import SmoothScroll from '../utils/SmoothScroll'
import Accordion from '../components/Accordion';
import AccordionCarousel from '../components/AccordionCarousel';
import VideoObserver from '../components/VideoObserver';
import HtmlVideoPlayer from '../components/HtmlVideoPlayer';
import VimeoVideoPlayer from '../components/VimeoVideoPlayer';
import Nav from '../components/Nav';
import PageObserver from '../components/PageObserver';
import BlockObserver from '../components/BlockObserver';
import Cookies from '../components/CookiesConsent';
import LoadPost from '../components/LoadPosts';
import ImageParallax from '../components/ImageParallax'; 
import Toggle from '../components/Toggle';
import Slideshow from '../components/Slideshow';
import Carousel from '../components/Carousel';
import TitleAnimation from '../components/TitleAnimation';
import StaffCredit from '../components/StaffCredit';
import ImageTicker from '../components/ImageTicker';
import ScrollSnapping from '../components/ScrollSnapping';
import Dropdown from '../components/Dropdown';
import Hero from '../components/Hero';
import HeroCollage from '../components/HeroCollage';
import Maps from '../components/Maps';
import Form from '../components/Form';
import CreditsWindow from '../components/CreditsWindow';
import LoadLogosGrid from '../components/LoadLogosGrid';
import FAQs from '../components/Faqs';
import Splide from "@splidejs/splide";
import HeroBusiness from '../components/HeroBusiness';
import AnchorLinks from '../components/AnchorLinks';
import Downloads from '../components/Downloads';
import Gallery from '../components/Gallery';
import Search from "../components/Search";

export default class App {
	constructor() {


		// ============================================================================================
		// SETUP APP
		// ============================================================================================

		// Create singleton
		if (instance) {
			return instance;
		}
		instance = this;


		// Create global access
		window.app = this;

		// ============================================================================================
		// GLOBAL FUNCTIONS
		// ============================================================================================

		// SETTING UP SMOOTH SCROLLING 
		this.smoothScroll = new SmoothScroll()

		// SETTING UP COOKIES
		this.cookies = new Cookies()


		this.pageObserver = new PageObserver()
		this.blockObserver = new BlockObserver(document.querySelectorAll('[data-watch="true"]'))
		this.loadPosts = new LoadPost();
		this.imageParallax = new ImageParallax();
		this.nav = new Nav();
		this.creditsWindow = new CreditsWindow();



		// ============================================================================================
		// COMPONENTS
		// ============================================================================================


		this.heros = document.querySelectorAll('[data-component="hero"]');
		this.heros && this.heros.forEach((hero) => {
			new Hero(hero);
		})


		this.heroCollage = document.querySelector('[data-component="herocollage"]');
		if(this.heroCollage){ 
			new HeroCollage(this.heroCollage);
		}


		this.heroBusiness = document.querySelectorAll('[data-component="herobusiness"]');
		this.heroBusiness && this.heroBusiness.forEach((hero) => {
			new HeroBusiness(hero);
		});


		this.accordions = document.querySelectorAll('[data-component="accordion"]');
		this.accordions && this.accordions.forEach((accordion) => {
			new Accordion(accordion).init();
		})

		this.gallery = document.querySelectorAll('[data-component="gallery"]');
		this.gallery && this.gallery.forEach((gallery) => {
			new Gallery(gallery);
		})

		this.search = document.querySelectorAll('[data-component="search"]');
		this.search && this.search.forEach((search) => {
			new Search(search);
		})


		this.toggles = document.querySelectorAll('[data-component="toggle"]');
		this.toggles && this.toggles.forEach((toggle) => {
			new Toggle(toggle).init();
		})


		this.carousel = document.querySelectorAll('[data-component="carousel"]');
		this.carousel && this.carousel.forEach((carousel)=>{
			new Carousel(carousel);
		})


		this.accordioncarousel = document.querySelectorAll('[data-component="accordioncarousel"]');
		this.accordioncarousel && this.accordioncarousel.forEach((accordioncarousel)=>{
			new AccordionCarousel(accordioncarousel);
		})


		this.slideshow = document.querySelectorAll('[data-component="slideshow"]');
		this.slideshow && this.slideshow.forEach((slideshow)=>{
			new Slideshow(slideshow);
		})


		this.titleAnimations = document.querySelectorAll('[data-component="title"]');
		this.titleAnimations && this.titleAnimations.forEach((titleAnimation)=>{
			new TitleAnimation(titleAnimation);
		})

		this.staffCredits = document.querySelectorAll('[data-component="staffcredit"]');
		this.staffCredits && this.staffCredits.forEach((staffCredit)=>{
			new StaffCredit(staffCredit);
		})

		this.forms = document.querySelectorAll('[data-component="forms"]');
		this.forms && this.forms.forEach((form)=>{
			new Form(form);
		})

		this.mainDownloads = document.querySelectorAll('[maindownloads]');
		this.mainDownloads && this.mainDownloads.forEach((mainDownloads)=>{
			new Downloads(mainDownloads);
		})

		this.splides = document.querySelectorAll('[data-component="splider"]');
		this.splides && this.splides.forEach((splide) => {
			let slider = new Splide(splide, {
				type: 'fade',
				rewind: true,
				drag: 'true',
				padding: 0,
				pagination: true,
				arrows: false,
				//autoplay: true,
			}).mount();

			let items 		= slider.length;
			let perPage	= slider.options.perPage;

			if ( items <= perPage ) {
				slider.options = {
					pagination: false,
				};
			}

			for (let item of slider.root.children[0].children[0].children[0].children) {
				item.classList.add('visible');
			}

			slider.on('click', function (slide) {
				for (let item of slide.slide.children) {
					item.classList.add('visible');
				}
			});

			slider.on('active', function (slide) {
				for (let item of slide.slide.children) {
					item.classList.add('visible');
				}
			});
			slider.on('inactive', function (slide) {
				for (let item of slide.slide.children) {
					item.classList.remove('visible');
				}
			});
		})

		this.formPicker 	= document.querySelectorAll('[formtoshow]');
		this.globalForms 	= document.querySelectorAll('[formtitle]');
		this.formPicker.forEach((formPicker) => {
			formPicker.addEventListener('click', (event) => {
				this.formPicker.forEach((formPicker) => {
					formPicker.classList.remove('b-forms__list--selected');
				})
				this.globalForms.forEach((globalForm) => {
					globalForm.classList.remove('b-forms__form--selected');
				})
				formPicker.classList.add('b-forms__list--selected');
				document.querySelector('[formtitle="'+formPicker.getAttribute('formtoshow')+'"]').classList.add('b-forms__form--selected');
			})
		})

		this.htmlVideos = document.querySelectorAll('.video--html');
		this.htmlVideos && this.htmlVideos.forEach((video)=>
		{

			let options =
			{
				autoplay: false,
				loop: true,
				muted: false,
				controls: true,
				cover: false,
				click: true,
				progress: true,
			}

			if( video.classList.contains('video--autoplay') ){
				options.autoplay = true;
				options.controls = false;
				options.muted 	 = true;
			}

			if( video.classList.contains('video--cover') ){
				options.cover = true;
			}
			
			new HtmlVideoPlayer(video, options);

		})

		this.vimeoVideos = document.querySelectorAll('.video--vimeo');
		this.vimeoVideos && this.vimeoVideos.forEach((video) => {
			let options =
			{
				autoplay: true,
				loop: true,
				muted: true,
				controls: true,
				progress: true,
			}
			new VimeoVideoPlayer(video, options);
		})


		this.imageTickers = document.querySelectorAll('[data-component="ticker"]');
		this.imageTickers && this.imageTickers.forEach((imageTicker)=>{
			new ImageTicker(imageTicker);
		})

		this.scrollSnappings = document.querySelectorAll('[data-component="scrollSnapping"]');
		this.scrollSnappings && this.scrollSnappings.forEach((scrollSnapping)=>{
			new ScrollSnapping(scrollSnapping);
		})

		this.dropdowns = document.querySelectorAll('[data-component="dropdown"]');
		this.dropdowns && this.dropdowns.forEach((dropdown)=>{
			new Dropdown(dropdown).init();
		})

		this.copyUrlClipboard = document.querySelectorAll('.copy-url-clipboard');
		this.copyUrlClipboard && this.copyUrlClipboard.forEach((copyUrl)=>{
			copyUrl.addEventListener('click', function (e) {
				navigator.clipboard.writeText(window.location.href);
				console.log('copied');
			})
		})

		this.maps = document.querySelectorAll('[data-component="map"]');
		this.maps && this.maps.forEach((map)=>{
			new Maps(map);
		})

		this.logosGrids = document.querySelectorAll('[data-component="logosGrid"]');
		this.logosGrids && this.logosGrids.forEach((logosGrid)=>{
			new LoadLogosGrid(logosGrid);
		})

		this.faqs = document.querySelectorAll('[data-component="faqs"]');
		this.faqs && this.faqs.forEach((faq)=>{
			new FAQs(faq);
		})

		this.anchorLinks = document.querySelectorAll('[data-component="anchorlinks"]');
		this.anchorLinks && this.anchorLinks.forEach((anchorLinks) => {
			new AnchorLinks(anchorLinks);
		});

		let readOnlyInputs = document.querySelectorAll('.gf_readonly input');
		readOnlyInputs.forEach((readOnlyInput) => {
			readOnlyInput.readOnly = true;
		})

		// Get context
		this.getContext();
		window.addEventListener('resize', () => {
			this.getContext();
		});

	}
	getContext() {

		// const isDesktop = window.matchMedia('(min-width: 1024px)');
		// const isTablet = window.matchMedia('(min-width: 768px) and (max-width: 1024px)');
		// const isMobile = window.matchMedia('(max-width: 768px)');
		
		// const handleResize = (e, size) => {
		// 	if (e.matches) {
		// 		console.log('viewport is ' + size + '!');  
		// 	} else {
		// 		// console.log('viewport below ' + size + '!');  
		// 	}
		// };
		
		// isDesktop.addEventListener('change', e => handleResize(e, 'desktop'));
		// isTablet.addEventListener('change', e => handleResize(e, 'tablet'));
		// isMobile.addEventListener('change', e => handleResize(e, 'mobile'));

		// // handleResize(isDesktop)


		if (window.matchMedia('(min-width: 1024px)').matches) {
			this.isDesktop = true;
		} else {
			this.isDesktop = false;
		}

		if (window.matchMedia('(min-width: 768px)').matches) {
			this.isTablet = true;
		} else {
			this.isTablet = false;
		}

		if (window.matchMedia('(max-width: 1024px)').matches) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}

		if (window.matchMedia('(hover: none)').matches) {
			this.isTouch = true;
		} else {
			this.isTouch = false;
		}

		if (window.location.host.includes('localhost')) {
			this.URL =
				'http://' +
				window.location.host +
				`/${REPO}/wp-content/themes/${THEME}`;
		} else {
			this.URL =
				'https://' + window.location.host + `/wp-content/themes/${THEME}`;
		}

	}
}
